import ko from "knockout";
import $ from "jquery";
import manifestManager from "flow/utils/manifestManager";
import register from "flow/knockout/register";

register.registerKnockoutBinding("classIdentifier", {
    init: function () {},
    update: function (element, valueAccessor) {
        const component = ko.utils.unwrapObservable(valueAccessor());

        if (component && !component.manifest.isShadow) {
            const manifest = component.manifest;
            const id = manifest.id;

            const sanitizedId = id.replace(/\./g, "_");

            let prefix = "unsupported_";

            if (manifestManager.isMenu(id)) {
                prefix = "menu_";
            } else if (manifestManager.isWorkingContext(id)) {
                prefix = "workingcontext_";
            } else if (manifestManager.isUserContextTab(id)) {
                prefix = "usercontexttab_";
            } else if (manifestManager.isComponent(id)) {
                prefix = "container_";
            }

            const className = prefix + sanitizedId;

            $(element).addClass(className);
        }
    }
});

register.registerKnockoutBinding("classIdentifierContainerNav", {
    init: function () {},
    update: function (element, valueAccessor) {
        const component = ko.utils.unwrapObservable(valueAccessor());

        if (component && !component.manifest.isShadow) {
            const manifest = component.manifest;
            const id = manifest.id;

            const sanitizedId = id.replace(/\./g, "_");

            const prefix = "containernav_";

            const className = prefix + sanitizedId;

            $(element).addClass(className);
        }
    }
});

register.registerKnockoutBinding("classIdentifierCommand", {
    init: function () {},
    update: function (element, valueAccessor) {
        const command = ko.utils.unwrapObservable(valueAccessor());

        if (command && command.commandId) {
            const commandId = ko.utils.unwrapObservable(command.commandId);

            if (commandId) {
                const sanitizedId = ko.utils.unwrapObservable(command.commandId).replace(/\./g, "_");

                const prefix = "command_";

                const className = prefix + sanitizedId;

                $(element).addClass(className);
            }
        }
    }
});

register.registerKnockoutBinding("classIdentifierNavigationPanel", {
    init: function () {},
    update: function (element, valueAccessor) {
        const navigationPanelItem = ko.utils.unwrapObservable(valueAccessor());

        if (navigationPanelItem && navigationPanelItem.id) {
            const sanitizedId = navigationPanelItem.id.replace(/\./g, "_");

            const prefix = "navigationpanel_";

            const className = prefix + sanitizedId;

            $(element).addClass(className);
        }
    }
});

register.registerKnockoutBinding("classIdentifierDialog", {
    init: function () {},
    update: function (element, valueAccessor) {
        const viewModel = ko.utils.unwrapObservable(valueAccessor());

        if (viewModel && viewModel.__myFlow && viewModel.__myFlow.id) {
            const sanitizedId = viewModel.__myFlow.id.replace(/\./g, "_");

            const prefix = "dialog_";

            const className = prefix + sanitizedId;

            $(element).addClass(className);
        }
    }
});
